import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function PublicMenue() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API}/menue/${token}/public`)
      .then((res) => setData(res.data))
      .catch(() => setError("Speisekarte nicht gefunden"))
      .finally(() => setLoading(false));
  }, [token]);

  if (loading) return <div className="min-h-screen bg-[#1a1410] text-[#f4ead5] flex items-center justify-center">Laden...</div>;
  if (error || !data) {
    return (
      <div className="min-h-screen bg-[#1a1410] text-[#f4ead5] flex items-center justify-center px-6 text-center">
        <div>
          <p className="text-2xl mb-2">🚫</p>
          <p>{error || "Keine Daten"}</p>
        </div>
      </div>
    );
  }

  const renderItems = (gruppen, label) => {
    if (!gruppen || gruppen.length === 0) return null;
    return (
      <section className="mb-8" data-testid={`section-${label.toLowerCase()}`}>
        <h2 className="text-xl tracking-widest uppercase text-[#e7c870] border-b border-[#45371f] pb-2 mb-4">{label}</h2>
        {gruppen.map((g) => (
          <div key={g.kategorie} className="mb-5">
            <h3 className="text-sm italic text-[#c9b07a] mb-2 opacity-90">{g.kategorie}</h3>
            <div>
              {g.items.map((it) => (
                <div key={it.id} className="py-2 border-b border-dashed border-[#3b3022] last:border-0">
                  <div className="flex items-baseline justify-between gap-3">
                    <span className="text-base text-[#f4ead5]">
                      {it.name}
                      {it.allergene?.length > 0 && (
                        <sup className="text-[10px] font-bold bg-[#3b3022] text-orange-400 px-1.5 py-0.5 rounded ml-2">
                          {it.allergene.join(",")}
                        </sup>
                      )}
                      {it.zusatzstoffe?.length > 0 && (
                        <sup className="text-[10px] font-bold bg-[#3b3022] text-slate-400 px-1.5 py-0.5 rounded ml-1">
                          [{it.zusatzstoffe.join(",")}]
                        </sup>
                      )}
                    </span>
                    <span className="font-bold text-[#e7c870] whitespace-nowrap">
                      {it.verkaufspreis.toFixed(2)} €
                    </span>
                  </div>
                  {it.beschreibung && (
                    <p className="text-xs opacity-70 mt-1 leading-relaxed">{it.beschreibung}</p>
                  )}
                </div>
              ))}
            </div>
          </div>
        ))}
      </section>
    );
  };

  return (
    <div className="min-h-screen bg-[#1a1410] text-[#f4ead5]" style={{ fontFamily: "Georgia, serif" }} data-testid="public-menue">
      <div className="max-w-2xl mx-auto px-6 pt-10 pb-16">
        <header className="text-center border-b border-[#6b5b40] pb-5 mb-7">
          <h1 className="text-3xl tracking-[3px] text-[#e7c870] mb-1">{data.firma?.firmenname || "Speisekarte"}</h1>
          <p className="text-xs uppercase tracking-[2px] opacity-75">
            {[data.firma?.adresse, data.firma?.stadt].filter(Boolean).join(" · ")}
          </p>
        </header>

        {renderItems(data.speisen, "Speisen")}
        {renderItems(data.getraenke, "Getränke")}

        <footer className="text-[10px] opacity-50 leading-relaxed border-t border-[#45371f] pt-4 mt-8 space-y-2">
          {data.allergene_liste && (
            <p>
              <b>Allergene:</b>{" "}
              {data.allergene_liste.map((a) => (
                <span key={a.code} className="inline-block mr-2">
                  <b>{a.code}</b> {a.name}
                </span>
              ))}
            </p>
          )}
          {data.zusatzstoffe_liste && (
            <p>
              <b>Zusatzstoffe:</b>{" "}
              {data.zusatzstoffe_liste.map((z) => (
                <span key={z.code} className="inline-block mr-2">
                  <b>{z.code}</b> {z.name}
                </span>
              ))}
            </p>
          )}
          <p className="text-center pt-2 opacity-70">powered by MargeVio</p>
        </footer>
      </div>
    </div>
  );
}
